import * as React from 'react'

import { Body, Text, TextWrapper, ThreadIconWrapper } from './styles'

export const Template: React.FC<{
  style?: React.CSSProperties
  texts: (string | undefined)[]
}> = ({ style, texts }) => {
  return (
    <Body style={style}>
      <ThreadIconWrapper>
        <span aria-label='Thread emoji' role='img'>
          🧵
        </span>
      </ThreadIconWrapper>
      <TextWrapper>
        <Text>{texts[0]}</Text>
        {texts[1] && <Text>{texts[1]}</Text>}
      </TextWrapper>
    </Body>
  )
}
